import css from './app.module.scss';

import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';

import { Admin } from 'com/Admin';
import Dashboard from 'com/Dashboard';
import { DeckEditorProvider } from 'com/DeckEditor';
import DeckGraph from 'com/DeckGraph';
import { WithHistoryModalProvider } from 'com/HistoryModal';
import { ImageViewerProvider } from 'com/ImageViewer';
import Login from 'com/Login';
import { Numbers } from 'com/Numbers';
import { QuestionEditorProvider } from 'com/QuestionEditor';
import QuestionList from 'com/QuestionList';
import { Test } from 'com/Test';
import { TestEditorProvider } from 'com/TestEditor';
import { UserEditorProvider } from 'com/UserEditor';
import { WordCards, Translate } from 'com/WordCards';
import { WordEditorProvider } from 'com/WordEditor';
import WordList from 'com/WordList';
import {
  getAdminUrl,
  getDashboardUrl,
  getDeckExerciseUrl,
  getDeckGraphUrl,
  getDeckUrl,
  getLoginUrl,
  getNumbersUrl,
  getTestQuestionsUrl,
  getTestUrl,
} from 'core/paths';
import Frame from 'core/ui/Frame';
import { MessageModalProvider } from 'core/ui/MessageModal';

import { ErrorBoundary } from './ErrorBoundary';
import { WithMeProvider } from './WithMe';

export default function Application() {
  return (
    <BrowserRouter>
      <Frame>
        <MessageModalProvider>
          <Providers>
            <Routes>
              <Route
                path={getDeckExerciseUrl(
                  `:deckUid`,
                  TExercise.wordCards,
                  ':wordUid?'
                )}
                element={<WordCards />}
              />
              <Route
                path={getDeckExerciseUrl(
                  `:deckUid`,
                  TExercise.wordCardsReverse,
                  ':wordUid?'
                )}
                element={<Translate />}
              />
              <Route path={getDeckUrl(':deckUid')} element={<WordList />} />
              <Route path={getLoginUrl()} element={<Login />} />
              <Route path={getDashboardUrl()} element={<Dashboard />} />
              <Route
                path={getDeckGraphUrl(':deckUid')}
                element={<DeckGraph />}
              />
              <Route path={getNumbersUrl(':lang')} element={<Numbers />} />
              <Route
                path={rmSearch(getTestUrl(`:testUid`))}
                element={<Test />}
              />
              <Route
                path={getTestQuestionsUrl(`:testUid`)}
                element={<QuestionList />}
              />
              <Route path="*" element={<Navigate to={getDashboardUrl()} />} />
              <Route path={getAdminUrl() + '*'} element={<Admin />} />
            </Routes>
          </Providers>
        </MessageModalProvider>
      </Frame>
    </BrowserRouter>
  );
}

const rmSearch = (url: string) => url.replace(/\?.+$/, '');

function pipe(
  ...providers: Array<React.ComponentType<{ children: React.ReactNode }>>
) {
  return function Providers({ children }: { children: React.ReactNode }) {
    return providers.reduceRight((acc, Provider) => {
      return <Provider>{acc}</Provider>;
    }, children);
  };
}

const Providers = pipe(
  ErrorBoundary,
  WithMeProvider,
  MessageModalProvider,
  ImageViewerProvider,
  UserEditorProvider,
  DeckEditorProvider,
  WordEditorProvider,
  TestEditorProvider,
  QuestionEditorProvider,
  WithHistoryModalProvider
);

// Prevent vite from dropping #root styles.
const keepStyles = (arg: unknown) => arg;
keepStyles(css);
